import { useState } from 'react'
import Icon from '@/components/Icons'
import { Spacing, Heading, Button } from '@big-red-group/storefront-common-ui'
import TrustFactorBar from '@/components/TrustFactorBar'
import Container from '@/components/Container'
import {
  Wrapper,
  Subtitle,
  Content,
  ContentLeft,
  ContentRight,
  Arrows,
  BackgroundLeft,
  BackgroundRight,
  ArrowLeft,
  ArrowRight,
  Background,
  TrustFactorsWrap,
  HeadingRight,
  IconWrapper,
} from './HomeBanner.styles'
import { UnderlineGraphic } from '@/components/Icons.styles'
import { useDefaultProperties } from '@/hooks/DefaultPropertiesHook'

export type HomeBannerSlide = {
  cta: string
  image: string
  link: string
  heading?: string
}

const HomeBanner: React.FC<{
  title: string
  subtitle: string
  banners: HomeBannerSlide[]
}> = ({ title, subtitle, banners }) => {
  const [currentBanner, setCurrentBanner] = useState<number>(0)
  const defaultProperties = useDefaultProperties()
  const agentHandlerKey = defaultProperties?.agentConfiguration?.handlerKey
  const agentCurrency = defaultProperties?.agentConfiguration?.currencyCode

  const handleLeftClick = () => {
    if (currentBanner === 0) {
      setCurrentBanner(banners.length - 1)
    } else {
      setCurrentBanner(currentBanner - 1)
    }
  }

  const handleRightClick = () => {
    if (currentBanner === banners.length - 1) {
      setCurrentBanner(0)
    } else {
      setCurrentBanner(currentBanner + 1)
    }
  }

  const isBrgAgent = defaultProperties?.agentConfiguration?.isBrgAgent

  return (
    <Wrapper data-mcp-id="minimal-home-banner">
      <BackgroundLeft>
        <Icon className="desktop" name={agentCurrency === 'NZD' ? 'homeBannerDesktopNz' : 'homeBannerWaveDesktopAu'} />
        <Icon className="mobile" name={agentCurrency === 'NZD' ? 'homeBannerMobileNz' : 'homeBannerWaveMobileAu'} />
      </BackgroundLeft>
      <Content>
        <Container spacing="XXXS">
          <ContentLeft>
            <Heading size="XXL" as="div" style={{ maxWidth: '460px' }}>
              {title}
              <UnderlineGraphic bottomOffset={'-22px'}>
                <Icon name="underline" width={76} height={7} fill="#1a1d1e" />
              </UnderlineGraphic>
            </Heading>
            <Spacing size="XXS" />
            <Subtitle>{subtitle}</Subtitle>

            {banners.length > 1 && (
              <Arrows>
                <ArrowLeft onClick={handleLeftClick} data-testid="arrow-left">
                  <Icon name="arrowCircleLeft" />
                </ArrowLeft>
                <ArrowRight onClick={handleRightClick} data-testid="arrow-right">
                  <Icon name="arrowCircleRight" />
                </ArrowRight>
              </Arrows>
            )}
          </ContentLeft>
          <ContentRight>
            {banners[currentBanner].heading && <HeadingRight>{banners[currentBanner].heading}</HeadingRight>}
            <Button size="M" onClick={() => (window.location.href = `${banners[currentBanner].link}`)}>
              {banners[currentBanner].cta}
            </Button>
          </ContentRight>
        </Container>
      </Content>
      <BackgroundRight activeBanner={currentBanner + 1}>
        {banners.map(({ image }, index) => (
          <Background key={index} image={image} data-testid={`image-${index}`} />
        ))}
      </BackgroundRight>
      {agentHandlerKey === 'virgin' && (
        <IconWrapper>
          <Icon name="velocityCampaign" />
        </IconWrapper>
      )}
      {isBrgAgent && (
        <TrustFactorsWrap>
          <TrustFactorBar />
        </TrustFactorsWrap>
      )}
    </Wrapper>
  )
}

export default HomeBanner
